import { Icon, IconsEnum } from 'components/Icons';
import { SimpleInfoModal } from 'components/modals/simpleInfoModal';
import { setIsOpenSimpleInfoValue } from 'features/modal/modalSlice';
import { RootState, useAppDispatch } from 'lib/centralStore';
import { ImageProps } from 'next/image';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './BonusCarouselItem.module.scss';

export type BonusCarouselItemProps = {
  id: string;
  typeOfBonus: string;
  text: string;
  bgImage: ImageProps;
  promoCode: string;
  informationTitle: string;
  informationText: string;
  index?: number;
  handleCurrentBonus?: Function;
  activeItem?: number | null;
  bonusSelected?: string;
};

export const BonusCarouselItem = ({
  id,
  typeOfBonus,
  text,
  promoCode,
  bgImage,
  informationTitle,
  informationText,
  index,
  handleCurrentBonus,
  activeItem,
  bonusSelected,
}: BonusCarouselItemProps) => {
  const { isOpenSimpleInfo } = useSelector((store: RootState) => store.modal);
  const [currentBonus, setCurrentBonus] = useState<string | null>(null);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isOpenSimpleInfo) {
      setCurrentBonus('');
    }
  }, [isOpenSimpleInfo]);

  const handleClickInfo = (event: React.MouseEvent<HTMLButtonElement>, id: string) => {
    event.stopPropagation();
    setCurrentBonus(id);
    if (event.currentTarget.id === id) {
      dispatch(
        setIsOpenSimpleInfoValue({
          condition: event.currentTarget.id === id,
          setModal: true,
        })
      );
    }
  };
  return (
    <React.Fragment>
      <article
        id={id}
        className={`${styles.container} ${activeItem === index ? styles.active : styles.inactive}`}
        style={{
          backgroundImage: `${bgImage && 'url(' + bgImage.src + ')'}`,
        }}
        onClick={(_) => {
          handleCurrentBonus && handleCurrentBonus(index, promoCode);
        }}
      >
        <span className={styles.type}>Bonus {typeOfBonus}</span>
        <div className={styles.textContainer}>
          <button id={id} type="button" className={styles.button} onClick={(e) => handleClickInfo(e, id)}>
            <Icon className={styles.icon} iconId={IconsEnum.INFO} color="var(--color-neutral-01)" />
          </button>
          <p className={styles.text}>{text}</p>
        </div>
      </article>
      {isOpenSimpleInfo && id === currentBonus && (
        <SimpleInfoModal
          isOpen={isOpenSimpleInfo}
          title={informationTitle}
          text={informationText}
          modalType={'secondary'}
        />
      )}
    </React.Fragment>
  );
};
